import jsonParser from 'utils/parseJson';
import { WalletType } from 'types';

import { BrandingType, IAgent } from './auth';

const jsonStringify = <T>(json: T): string => JSON.stringify(json);

export const authStorage = {
  set: (data: { agent: IAgent; accessToken: string; branding?: BrandingType }): void => {
    localStorage.setItem('agent', jsonStringify<IAgent>(data.agent));
    localStorage.setItem('accessToken', jsonStringify<string>(data.accessToken));
    if (data?.branding) {
      localStorage.setItem('branding', jsonStringify<BrandingType>(data?.branding));
    }
  },
  get: (): { agent: IAgent; accessToken: string; wallets: WalletType[]; branding: BrandingType } => ({
    agent: jsonParser(localStorage.getItem('agent') || ''),
    accessToken: jsonParser(localStorage.getItem('accessToken') || ''),
    branding: jsonParser(localStorage.getItem('branding') || ''),
    wallets: [],
  }),
  remove: (): void => {
    localStorage.removeItem('agent');
    localStorage.removeItem('accessToken');
  },
  clear: (): void => {
    localStorage.clear();
    window.location.reload();
    window.location.pathname = '/';
  },
};
